(function (root) {
  'use strict';
  function day(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return NaN;
    const result = Date.parse(value + 'T00:00:00Z');
    return Number.isFinite(result) && new Date(result).toISOString().slice(0, 10) === value ? result / 86400000 : NaN;
  }
  function today() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
    const get = type => parts.find(part => part.type === type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  }
  function monthLabel(value) {
    return new Intl.DateTimeFormat('es-ES', { month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(value + 'T12:00:00Z')).replace(' de ', ' ').toLowerCase();
  }
  function calculate(config, date, selected, choice, current, couponCode) {
    const difference = day(date) - day(current);
    if (!Number.isFinite(difference)) return { valid: false, reason: 'date' };
    const capacityDate = difference < 0 ? current : date;
    const reservation = config.reservations.find(item => item.month.toLowerCase() === monthLabel(capacityDate));
    if (!reservation) return { valid: false, reason: 'closed' };
    if (!reservation.available) return { valid: false, reason: 'soldout' };
    const keys = Array.from(new Set(selected)).filter(key => key !== 'videographer');
    if (keys.includes('priority') && keys.includes('express')) return { valid: false, reason: 'extras' };
    const extraItems = keys.map(key => config.products[key]);
    if (!config.products.service?.available || extraItems.some(item => !item?.available)) return { valid: false, reason: 'extras' };
    const service = config.products.service;
    const prices = [reservation, service, ...extraItems];
    if (prices.some(item => !Number.isSafeInteger(item.price) || item.price < 0)) return { valid: false, reason: 'extras' };
    const gross = prices.reduce((sum, item) => sum + item.price, 0);
    const coupon = (couponCode || '').trim().toUpperCase();
    const promotion = coupon && config.promotion?.codes?.[coupon];
    if (coupon && (!promotion || day(current) < day(config.promotion.starts) || day(current) > day(config.promotion.ends) || reservation.price + service.price !== config.promotion.basic || promotion.amount > service.price)) return { valid: false, reason: 'coupon' };
    const discount = promotion ? promotion.amount : 0;
    const total = gross - discount;
    const full = difference <= 7 || choice === 'full';
    const payable = full ? total : reservation.price;
    const items = full ? prices : [reservation];
    return { valid: true, full, past: difference < 0, near: difference >= 0 && difference <= 7, total, gross, discount, coupon, payable, balance: total - payable, reservation, extraItems, items, difference, capacityDate };
  }
  function permalink(config, result, properties, email) {
    if (!result.valid) throw new Error('Invalid checkout');
    const bytes = new TextEncoder().encode(JSON.stringify(properties));
    const encoded = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join('')).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const params = new URLSearchParams({ properties: encoded, 'checkout[email]': email.trim() });
    if (result.full && result.coupon) params.set('discount', result.coupon);
    return config.cartUrl + '/' + result.items.map(item => String(item.id) + ':1').join(',') + '?' + params.toString();
  }
  const api = { calculate, permalink, day, today };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.BCCheckout = api;
  if (!root.document) return;
  function initialize() {
    root.document.querySelectorAll('[data-bc-checkout]').forEach(form => {
      if (form.dataset.initialized) return;
      const data = form.parentElement.querySelector('[data-bc-catalog]');
      if (!data) return;
      let config;
      try { config = JSON.parse(data.textContent); } catch (_) { return; }
      form.dataset.initialized = 'true';
      const find = selector => form.querySelector(selector);
      const date = find('[data-date]');
      const choice = find('[data-payment-choice]');
      const coupon = find('[data-coupon]');
      const status = find('[data-status]');
      const button = find('button[type="submit"]');
      const selected = () => Array.from(form.querySelectorAll('[data-extra]:checked')).map(input => input.dataset.extra);
      const money = value => new Intl.NumberFormat('es-ES', { style: 'currency', currency: config.currency }).format(value / 100);
      let busy = false;
      let voluntaryChoice = choice.value;
      function update() {
        const keys = selected();
        const result = calculate(config, date.value, keys, voluntaryChoice, today(), coupon?.value);
        const discountRow = find('[data-discount-row]');
        if (discountRow) {
          discountRow.hidden = !result.discount;
          find('[data-discount]').textContent = result.discount ? '− ' + money(result.discount) : '';
          find('[data-coupon-note]').textContent = result.discount ? (result.full ? config.messages.couponFull : config.messages.couponDeposit) : '';
        }
        form.querySelectorAll('[data-extra-price]').forEach(element => {
          const product = config.products[element.dataset.extraPrice];
          element.textContent = product ? (product.price === 0 ? config.messages.gift : '+ ' + money(product.price)) : config.messages.unavailable;
        });
        button.disabled = busy || !result.valid;
        find('[data-quote-warning]').hidden = !keys.includes('usb') && !keys.includes('videographer');
        if (!result.valid) {
          status.textContent = config.messages[result.reason] || config.messages.unavailable;
          const base = (config.reservations[0]?.price || 0) + (config.products.service?.price || 0);
          const extras = keys.filter(key => key !== 'videographer').reduce((sum, key) => sum + (config.products[key]?.price || 0), 0);
          find('[data-total]').textContent = money(base + extras);
          ['payable', 'balance'].forEach(key => find('[data-' + key + ']').textContent = config.messages.pickPayment);
          button.textContent = config.messages.continue;
          find('[data-payment-note]').textContent = '';
          choice.disabled = false;
          return result;
        }
        ['total', 'payable', 'balance'].forEach(key => find('[data-' + key + ']').textContent = money(result[key]));
        choice.disabled = result.difference <= 7;
        choice.value = result.difference <= 7 ? 'full' : voluntaryChoice;
        status.textContent = result.past ? config.messages.past : config.messages.available.replace('__COUNT__', String(result.reservation.quantity));
        find('[data-payment-note]').textContent = result.full ? config.messages.fullNote : config.messages.depositNote;
        button.textContent = (result.full ? config.messages.pay : config.messages.reserve) + ' ' + money(result.payable);
        return result;
      }
      async function refresh(keys) {
        const entries = [['reservation', config.reservationHandle], ['service', config.products.service.handle], ...keys.filter(key => key !== 'videographer').map(key => [key, config.products[key].handle])];
        const responses = await Promise.all(entries.map(async ([key, handle]) => {
          const response = await fetch(config.rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('catalog');
          const product = await response.json();
          if (!Array.isArray(product.variants)) throw new Error('catalog');
          return [key, product];
        }));
        for (const [key, product] of responses) {
          if (key === 'reservation') {
            config.reservations.forEach(item => {
              const variant = product.variants.find(v => String(v.id) === String(item.id));
              item.available = !!variant?.available;
              if (variant) item.price = variant.price;
            });
          } else {
            const item = config.products[key];
            const variant = product.variants.find(v => String(v.id) === String(item.id));
            item.available = !!variant?.available;
            if (variant) item.price = variant.price;
          }
        }
      }
      form.addEventListener('change', event => {
        if (event?.target === choice) voluntaryChoice = choice.value;
        const delivery = event.target;
        if (delivery?.checked && ['priority', 'express'].includes(delivery.dataset.extra)) {
          form.querySelectorAll('[name="bc-delivery"]').forEach(input => {
            if (input !== delivery) input.checked = false;
          });
        }
        update();
      });
      coupon?.addEventListener('input', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const before = update();
        if (!before.valid) return;
        busy = true;
        button.disabled = true;
        status.textContent = config.messages.checking;
        const keys = selected();
        const inputDate = date.value;
        const inputChoice = choice.value;
        const inputCoupon = coupon?.value;
        const signature = result => JSON.stringify([result.total, result.payable, result.balance, result.items?.map(item => [item.id, item.price])]);
        const beforeSignature = signature(before);
        try {
          await refresh(keys);
          busy = false;
          const result = update();
          if (!result.valid) return;
          if (date.value !== inputDate || choice.value !== inputChoice || coupon?.value !== inputCoupon || JSON.stringify(selected()) !== JSON.stringify(keys) || signature(result) !== beforeSignature) {
            status.textContent = config.messages.changed;
            return;
          }
          const properties = {
            'Fecha de la boda': date.value,
            'Correo electrónico': find('[data-email]').value.trim(),
            'Teléfono de contacto': find('[data-phone]').value.trim(),
            'Modalidad de pago': result.full ? 'Pago completo' : 'Reserva',
            'Total del servicio sin envío ni videógrafo': money(result.total),
            'Pagado en este pedido (si se completa)': money(result.payable),
            'Saldo pendiente sin envío ni videógrafo': money(result.balance),
            'Complementos solicitados': keys.map(key => key === 'videographer' ? 'Videógrafo: solicitar presupuesto' : config.products[key].title + ' (' + money(config.products[key].price) + ')').join('; ') || 'Sin complementos',
            'Mes de capacidad': result.reservation.month,
            'Código promocional': result.coupon || 'Sin cupón',
            'Descuento sobre el básico': money(result.discount),
            'Comprobación del cupón': result.coupon ? (result.full ? 'Shopify valida el código al pagar' : 'Verificar un uso por cliente antes de emitir el enlace del saldo') : 'No procede',
            '_bc_payment_version': '3',
            '_bc_coupon': result.coupon,
            '_bc_discount_cents': String(result.discount),
            '_bc_extras': JSON.stringify(keys),
            '_bc_total_cents': String(result.total)
          };
          const url = permalink(config, result, properties, find('[data-email]').value);
          busy = true;
          button.disabled = true;
          window.location.assign(url);
        } catch (_) {
          busy = false;
          update();
          status.textContent = config.messages.error;
        }
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
})(typeof window === 'undefined' ? globalThis : window);
